import { useNavigate } from "react-router-dom";
import BackButton from "../siteSetting/components/BackButton";

const PageHeader = ({
    title,
    buttonText,
    handleShow,
    backButtonProduct,
    noneHrefButton,
    href,
    backHref,
    noneCreateButton,
    headerActions,
    headerActionsAfter,
    headerLayout = "centered",
    backButtonInActions = false,
}) => {
    const navigate = useNavigate();

    const goBack = () => navigate(-1);

    const backPropsByHref = backHref
        ? { href: backHref }
        : backButtonProduct
            ? { href: "/containerProductPage" }
            : null;

    const backPropsByClick = !backPropsByHref && noneHrefButton
        ? { onClick: goBack }
        : null;

    const backProps = backPropsByHref || backPropsByClick;

    const handlePrimaryAction = () => {
        if (typeof handleShow === "function") {
            handleShow();
            return;
        }

        if (href) {
            navigate(href);
        }
    };

    const showPrimaryAction =
        !noneCreateButton
        && (typeof handleShow === "function" || href);

    const showBackOnLeft = Boolean(backProps && !backButtonInActions);
    const showBackInsideActions = Boolean(backProps && backButtonInActions);

    const showActions = Boolean(
        showBackInsideActions
        || headerActions
        || showPrimaryAction
        || headerActionsAfter
    );

    const headerClassName = [
        "ms-header",
        headerLayout === "titleStart" ? "ms-header--title-start" : "",
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <header className={headerClassName} role="banner">
            <div className="ms-header__left">
                {showBackOnLeft ? (
                    <BackButton className="backButton" {...backProps} />
                ) : null}
            </div>

            <h1 className="ms-header__title">{title}</h1>

            {showActions ? (
                <div className="ms-header__actionsViewport">
                    <div className="ms-header__actionsTrack">
                        {showBackInsideActions ? (
                            <div className="ms-header__back-action">
                                <BackButton className="backButton" {...backProps} />
                            </div>
                        ) : null}

                        {headerActions ? (
                            <div className="ms-header__secondary-actions">
                                {headerActions}
                            </div>
                        ) : null}

                        {showPrimaryAction ? (
                            <button
                                type="button"
                                className="ms-header__upload"
                                onClick={handlePrimaryAction}
                            >
                                {buttonText || "Новый"}
                            </button>
                        ) : null}

                        {headerActionsAfter ? (
                            <div className="ms-header__secondary-actions ms-header__secondary-actions--after">
                                {headerActionsAfter}
                            </div>
                        ) : null}
                    </div>
                </div>
            ) : (
                <div className="ms-header__actionsViewport ms-header__actionsViewport--empty" />
            )}
        </header>
    );
};

export default PageHeader;
